// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1aoAx","tab":"Tabs_tab__2Sw53","tabActive":"Tabs_tabActive__3tjCy"};